import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-media-gallery-delete-dialog',
  templateUrl: './media-gallery-delete-dialog.component.html',
  styleUrls: ['./media-gallery-delete-dialog.component.scss']
})
export class MediaGalleryDeleteDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<MediaGalleryDeleteDialogComponent>) { }

  ngOnInit() {
  }

  public delete() {
    this.dialogRef.close(true);
  }

  public cancel() {
    this.dialogRef.close();
  }

  public getSelectedItemsLength() {
    return this.getSelectedImagesLength() + this.getSelectedVideosLength() + this.getSelectedHtmlLength();
  }

  public getSelectedImagesLength() {
    if (this.data) {
      return this.data.selectedImages.length;
    }
  }
  public getSelectedVideosLength() {
    if (this.data) {
      return this.data.selectedVideos.length;
    }
  }
  public getSelectedHtmlLength() {
    if (this.data) {
      return this.data.selectedHtmls.length;
    }
  }
}
